// Mock data for Kip Energy Landing Page

export const heroData = {
  title: "L'Énergie au Cœur de Votre Quotidien",
  subtitle: "Distributeur Exclusif Wayne en Côte d'Ivoire",
  description: "Acteur intégré de la chaîne de valeur énergétique, Kip Energy distribue les carburants Wayne de qualité supérieure, développe des infrastructures pétrolières modernes et facilite l'approvisionnement en produits pétroliers pour toute la Côte d'Ivoire.",
  ctas: [
    { label: "Trouver une Station Wayne", href: "#stations", variant: "primary" },
    { label: "Devenir Partenaire", href: "#contact", variant: "secondary" },
    { label: "Nos Services Entreprises", href: "#services", variant: "outline" }
  ]
};

export const visionData = {
  title: "Votre Partenaire Énergétique Intégré",
  description: "De la distribution de carburants au développement d'infrastructures stratégiques, Kip Energy s'impose comme un acteur complet de la chaîne énergétique ivoirienne. Notre ambition : contribuer à la sécurité énergétique de la Côte d'Ivoire en combinant excellence opérationnelle, standards internationaux et ancrage local."
};

export const metiersData = [
  {
    id: 1,
    icon: "Fuel",
    title: "Distribution Wayne",
    subtitle: "50+ Stations-Service à Travers le Pays",
    description: "Carburants premium, lubrifiants de qualité, consommables automobiles, services complets pour tous vos déplacements.",
    cta: "Découvrir"
  },
  {
    id: 2,
    icon: "Building2",
    title: "Infrastructures Pétrolières",
    subtitle: "Développement & Modernisation",
    description: "Capacités de stockage modernes, technologies de pointe, normes internationales pour une sécurité énergétique optimale.",
    cta: "Découvrir"
  },
  {
    id: 3,
    icon: "Ship",
    title: "Trading Pétrolier",
    subtitle: "Approvisionnement & Logistique",
    description: "Commerce de brut et produits raffinés, logistique intégrée, solutions sur-mesure pour entreprises et institutions.",
    cta: "Découvrir"
  }
];

export const statsData = [
  { value: "50+", label: "Stations-Service", description: "Objectif 2030" },
  { value: "140", label: "Ans d'Expertise", description: "Wayne International" },
  { value: "360°", label: "Vision Intégrée", description: "De l'importation à la distribution" },
  { value: "4", label: "Certifications", description: "ISO 9001, 14001, 45001, BIVAC" }
];

export const aboutData = {
  title: "À Propos de Kip Energy",
  intro: "Kip Energy est la filiale énergétique du Groupe EKIP Holding Company, positionnée comme acteur intégré sur toute la chaîne de valeur pétrolière en Côte d'Ivoire.",
  vision: {
    title: "Notre Vision",
    text: "Devenir l'acteur de référence de la chaîne de valeur énergétique en Côte d'Ivoire et en Afrique de l'Ouest, en combinant distribution de proximité, infrastructures stratégiques et solutions d'approvisionnement innovantes."
  },
  values: [
    { icon: "Award", title: "Excellence Opérationnelle", description: "Standards internationaux de qualité" },
    { icon: "Shield", title: "Sécurité", description: "Zéro compromis sur la sécurité" },
    { icon: "CheckCircle", title: "Fiabilité", description: "Partenaire de confiance" },
    { icon: "Lightbulb", title: "Innovation", description: "Technologies de pointe" },
    { icon: "Heart", title: "Responsabilité", description: "Engagement RSE fort" },
    { icon: "Link", title: "Intégration", description: "Chaîne de valeur complète" }
  ]
};

export const waynePartnershipData = {
  title: "Wayne International : 140 Ans d'Excellence",
  description: "Fondé en 1885 aux États-Unis, Wayne est un acteur majeur mondial de l'industrie pétrolière avec une expertise reconnue en infrastructures et distribution de qualité supérieure.",
  highlights: [
    "Plus de 20 projets d'envergure en Afrique",
    "Investissement cumulé > 500 millions USD",
    "Présence au Nigeria, Kenya, Ghana, Sénégal"
  ],
  benefits: [
    { icon: "Star", title: "Qualité Produits Supérieure" },
    { icon: "Globe", title: "Expertise Technique Internationale" },
    { icon: "Network", title: "Réseau d'Approvisionnement Mondial" },
    { icon: "GraduationCap", title: "Formation & Support Continu" }
  ]
};

export const productsData = {
  title: "Nos Produits Wayne",
  categories: [
    {
      title: "Carburants Premium",
      items: [
        { name: "Wayne Super 95", description: "Essence sans plomb 95 octanes, additifs détergents" },
        { name: "Wayne Diesel", description: "Gazole ultra-basse teneur soufre (<50 ppm)" },
        { name: "Wayne Premium 98", description: "Essence haute performance 98 octanes" }
      ]
    },
    {
      title: "Lubrifiants",
      items: [
        { name: "Gamme Automobile", description: "Huiles moteur, transmission, liquides" },
        { name: "Gamme Industrielle", description: "Huiles hydrauliques, compresseurs" },
        { name: "Gamme Marine", description: "Huiles moteurs marins" }
      ]
    }
  ]
};

export const servicesData = {
  title: "Services en Station",
  standard: [
    "Distribution Carburants 24/7",
    "Gonflage Gratuit",
    "Toilettes Propres",
    "Wi-Fi Gratuit",
    "Mini-Market"
  ],
  premium: [
    "Lavage Automobile",
    "Vidange Express",
    "Diagnostic Électronique",
    "Boutique EKIPTECH",
    "Espace Restauration"
  ]
};

export const engagementsData = [
  {
    icon: "BadgeCheck",
    title: "Qualité",
    description: "Certifications ISO 9001:2015, BIVAC, Standards Wayne. Contrôles quotidiens et traçabilité complète."
  },
  {
    icon: "ShieldCheck",
    title: "Sécurité",
    description: "ISO 45001:2018, équipements conformes NFPA/API. Objectif zéro accident."
  },
  {
    icon: "Leaf",
    title: "Environnement",
    description: "ISO 14001:2015, réduction émissions, énergies renouvelables. Objectif -50% carbone d'ici 2030."
  },
  {
    icon: "Users",
    title: "Responsabilité Sociale",
    description: "Emploi local prioritaire, programmes communautaires, transparence et dialogue."
  }
];

export const ecosystemData = {
  title: "L'Écosystème EKIP",
  subtitle: "Synergies au Service de Votre Réussite",
  companies: [
    { name: "Ekip Holding Company", description: "Groupe d'Investissement", logo: "https://customer-assets.emergentagent.com/job_5cce6493-f0af-4302-8a9d-51bbe4853e8f/artifacts/dmphbg7d_Logo%20Holding.jpg" },
    { name: "KIDH", description: "Immobilier & Construction", logo: "https://customer-assets.emergentagent.com/job_5cce6493-f0af-4302-8a9d-51bbe4853e8f/artifacts/tolnsvcl_Logo%20Filiale%20KIDH.png" },
    { name: "Wayne CI", description: "Distribution Carburants", logo: "https://customer-assets.emergentagent.com/job_5cce6493-f0af-4302-8a9d-51bbe4853e8f/artifacts/s7cwyypr_Logo%20Filiale%20Wayne%20CI%20by%20Kip%20Energy.png" },
    { name: "Kipay", description: "Solutions de Paiement", logo: "https://customer-assets.emergentagent.com/job_5cce6493-f0af-4302-8a9d-51bbe4853e8f/artifacts/sy025an7_Logo%20Filiale%20Kipay.png" },
    { name: "Ekiptech", description: "Technologies & Innovation", logo: "https://customer-assets.emergentagent.com/job_5cce6493-f0af-4302-8a9d-51bbe4853e8f/artifacts/sgchezoo_Logo%20Filiale%20Ekiptech.png" }
  ]
};

export const contactData = {
  title: "Nous Contacter",
  subtitle: "Notre équipe est à votre disposition",
  address: "49 rue 104 Blvd Latrille Cocody, Abidjan, Côte d'Ivoire",
  phones: [
    { label: "Standard", number: "+225 27 22 41 25 25" },
    { label: "Stations-Service", number: "+225 05 06 06 55 06" },
    { label: "Urgences 24/7", number: "+225 05 06 06 55 06" }
  ],
  emails: [
    { label: "Contact Général", email: "contact@kipenergy.ci" },
    { label: "Commercial", email: "commercial@kipenergy.ci" },
    { label: "Partenariat", email: "partenariat@kipenergy.ci" }
  ],
  hours: "Lundi - Vendredi: 8h00 - 17h30 | Samedi: 8h00 - 12h00",
  subjects: [
    "Stations-Service",
    "Partenariat Gérant",
    "Trading & Approvisionnement",
    "Infrastructures",
    "Réclamation",
    "Presse",
    "Autre"
  ]
};

export const footerData = {
  description: "Acteur intégré de la chaîne de valeur énergétique en Côte d'Ivoire. Distributeur exclusif Wayne.",
  quickLinks: [
    { label: "Accueil", href: "#hero" },
    { label: "Nos Métiers", href: "#services" },
    { label: "À Propos", href: "#about" },
    { label: "Contact", href: "#contact" }
  ],
  services: [
    { label: "Distribution Wayne", href: "#" },
    { label: "Infrastructures", href: "#" },
    { label: "Trading Pétrolier", href: "#" },
    { label: "Devenir Partenaire", href: "#contact" }
  ],
  socials: [
    { name: "LinkedIn", url: "https://linkedin.com" },
    { name: "Facebook", url: "https://facebook.com" },
    { name: "Instagram", url: "https://instagram.com" },
    { name: "Twitter", url: "https://twitter.com" }
  ],
  copyright: "© 2025 Kip Energy. Tous droits réservés. Membre du Groupe EKIP Holding Company."
};

export const navLinks = [
  { label: "Accueil", href: "#hero" },
  { label: "Nos Métiers", href: "#services" },
  { label: "Stations", href: "#stations" },
  { label: "À Propos", href: "#about" },
  { label: "Partenaires", href: "#partners" },
  { label: "Engagements", href: "#engagements" },
  { label: "Contact", href: "#contact" }
];

export const logoUrl = "https://customer-assets.emergentagent.com/job_5cce6493-f0af-4302-8a9d-51bbe4853e8f/artifacts/naavnpnn_Logo%20KIP%20ENERGY.png";

export const logoUrlTransparent = "https://customer-assets.emergentagent.com/job_5cce6493-f0af-4302-8a9d-51bbe4853e8f/artifacts/8a93yu1a_Kip%20Energy.png";
